<template>
  <BaseModal>
    <div class="w-full">
      <div>
        <BaseInput v-model="state.terminal.terminalId" label="Terminalid" />
        <BaseInput
          v-model="state.terminal.username"
          label="Användarnamn"
          class="mt-3"
        />
        <BaseInput
          v-model="state.terminal.password"
          label="Lösenord"
          class="mt-3"
        />
        <div class="mt-3">
          <BaseLabel label="Salong" />
          <select v-model="state.selectedSaloon" class="form-control">
            <option :value="null">Välj...</option>
            <option
              v-for="saloon of saloons"
              :key="saloon.id"
              :value="saloon.id"
              >{{ saloon.name }}
              <span v-if="saloon.company && saloon.company.parentCompany"
                >Hyrstol</span
              ></option
            >
          </select>
        </div>
        <div class="mt-3">
          <BaseLabel label="Leverantör" />
          <select v-model="state.terminal.provider" class="form-control">
            <option :value="null">Välj...</option>
            <option
              v-for="provider of ['ADYEN', 'NETS']"
              :key="provider"
              :value="provider"
              >{{ provider }}
            </option>
          </select>
        </div>

        <BaseInput
          v-if="state.terminal.provider === 'ADYEN'"
          v-model="state.terminal.displayName"
          class="mt-3"
          label="Etikett"
          placeholder="Frivillig etikett"
        />
      </div>
    </div>
    <template #footer>
      <button class="btn btn-default" @click="close">Stäng</button>
      <button
        class="btn btn-secondary"
        :disabled="!state.selectedSaloon"
        @click="save"
      >
        Spara
      </button>
    </template>
  </BaseModal>
</template>

<script>
import CREATE_TERMINAL from '@/graphql/CreateTerminal.gql'
import BaseModal from '@/components/BaseModal'
import { useSaloons } from '@/composables/use-saloons'
import { reactive } from '@vue/composition-api'

export default {
  components: {
    BaseModal,
  },
  setup(props, { root, emit }) {
    const state = reactive({
      terminal: {
        provider: 'NETS',
      },
      submitLoading: false,
      selectedSaloon: null,
    })
    const { saloons } = useSaloons(root.$route.params.id)

    const close = () => {
      root.$router.push({
        name: 'companydetails',
        params: { id: root.$route.params.id },
      })
    }

    const save = async () => {
      try {
        state.submitLoading = true

        await root.$apollo.mutate({
          mutation: CREATE_TERMINAL,
          variables: {
            data: {
              companyId: root.$route.params.id,
              saloonId: state.selectedSaloon,
              ...state.terminal,
            },
          },
        })
        emit('refresh')
        root.$router.push({
          name: 'companydetails',
          params: { id: root.$route.params.id },
        })
      } catch (error) {
        console.log(error)
      } finally {
        state.submitLoading = false
      }
    }

    return {
      state,
      saloons,
      close,
      save,
    }
  },
}
</script>
